import { useEffect, useRef, useState } from "react";
import styles from "./Opportunities.module.css";
import { useDispatch, useSelector } from "react-redux";
import Langs, { Localize } from "../../app/lang/langs";
import ImageButton from "../../components/buttons/ImageButton";
import { getOpportunities } from "../../components/clients/clientsSlice";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import addIcon from '../../assets/images/add.png'
import addIconFocus from '../../assets/images/addFocus.png'
import { useNavigate } from "react-router-dom";
import { Tag } from "primereact/tag";
import { FilterMatchMode } from "primereact/api";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Col, Row } from "react-bootstrap";
import { Dropdown } from "primereact/dropdown";
import moment from "moment";
import { checkPermission } from "../../app/utils/helpers";
import { config } from "../../app/utils/config";
import exportIcon from "../../assets/images/export.png";
import exportIconFocus from "../../assets/images/exportFocus.png";
import OpportunityModal from "./OpportunityModal";
import ExcelManager from "../../app/managers/excelManager";


export default function OpportunitiesTab() {

    const mounted = useRef(null)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const dtOpp = useRef();

    const [detailsModalVisibility, setDetailsModalVisibility] = useState(false);
    const [oppDetailed, setOppDetailed] = useState(null)
    const [addOpportunitieModalVisible, setAddOpportunitieModalVisible] = useState(false)
    const [filteredOpportunities, setFilteredOpportunities] = useState(null);

    useEffect(() => {
        if (!mounted.current) {
            dispatch(getOpportunities())
        }
        mounted.current = true
    }, [mounted])

    const isMobile = useSelector((state) => state.settings.isMobile);
    const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)
    const oppList = useSelector((state) => state.clients.opportunities)

    const [localOppList, setLocalOppList] = useState([])

    useEffect(() => { setLocalOppList(oppList) }, [oppList])

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        poste_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        title: { value: null, matchMode: FilterMatchMode.CONTAINS },
        localisation: { value: null, matchMode: FilterMatchMode.CONTAINS },
        description: { value: null, matchMode: FilterMatchMode.CONTAINS },
        status: { value: null, matchMode: FilterMatchMode.CONTAINS },
        competences: { value: null, matchMode: FilterMatchMode.CONTAINS },
        team_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        category: { value: null, matchMode: FilterMatchMode.CONTAINS },
        priority: { value: null, matchMode: FilterMatchMode.CONTAINS },
        demanded_by_nom: { value: null, matchMode: FilterMatchMode.CONTAINS },
        demanded_by_prenom: { value: null, matchMode: FilterMatchMode.CONTAINS },
        handled_by_nom: { value: null, matchMode: FilterMatchMode.CONTAINS },
        handled_by_prenom: { value: null, matchMode: FilterMatchMode.CONTAINS },
        helped_by_prenom: { value: null, matchMode: FilterMatchMode.CONTAINS },
        helped_by_nom: { value: null, matchMode: FilterMatchMode.CONTAINS },
        sub_status: { value: null, matchMode: FilterMatchMode.CONTAINS },
        response_comments: { value: null, matchMode: FilterMatchMode.CONTAINS }
    })

    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    }

    const competenceTemplate = (rowData) => {
        if (!rowData.competences) {
            return <span>No competences listed</span>;
        }
        let competences = [];
        try {
            competences = rowData.competences.split('\n');
        } catch (e) {
            console.error('Error parsing competences:', e);
        }
        return (
            <ul>
                {competences.map((competence, index) => (
                    <li key={index}>{competence}</li>
                ))}
            </ul>
        )
    }

    const exportExcelOpportunities = () => {
        let filteredData = filteredOpportunities || localOppList;

        let exportData = filteredData.reduce((array, current) => {

            let opportunityData = {
                "Titre": current.title || "",
                "Equipe": current.team_name || "",
                "Localisation": current.localisation || "",
                "Poste": current.poste_name || "",
                "Catégorie": current.category || "",
                "Priorité": current.priority || "",
                "Profils recherchés": current.profiles_number,
                "Profils fournis": current.provided_profiles_number,
                "Date de début": current.start_date ? moment(current.start_date).format('DD/MM/YYYY') : "",
                "Sous-Statut": current.sub_status || "",
                "Description": current.description || "",
                "Compétences": current.competences || "",
                "Commentaires": current.response_comments || "",
                "Aidé par (Prénom)": current.helped_by_prenom || "",
                "Aidé par (Nom)": current.helped_by_nom || "",
                "Demandé par (Prénom)": current.demanded_by_prenom || "",
                "Demandé par (Nom)": current.demanded_by_nom || "",
                "Géré par (Prénom)": current.handled_by_prenom || "",
                "Géré par (Nom)": current.handled_by_nom || ""
            };

            array.push(opportunityData)
            return array;
        }, []);

        ExcelManager.getInstance().generateAndDownloadExcelFromData(exportData, "Opportunités");
    };

    const textTemplate = (rowData, field) => (
        <div className={styles.textMask} title={rowData[field]}>
            {rowData[field]}
        </div>
    )

    const onRowDoubleClick = (e) => {
        if (checkPermission(config.scopes.opportunities, config.permissionTypes.edit)) {
            setDetailsModalVisibility(true)
            setOppDetailed(e.data)
        }
    }

    const priorityBodyTemplate = (rowData) => {
        return <div style={{ color: (["Normale"].includes(rowData.priority) ? "green" : (["Urgent"].includes(rowData.priority) ? "red" : "")) }}>
            <strong>{rowData.priority}</strong>
        </div>
    }

    const navToTeam = (rowData) => {
        const encodedLabel = encodeURIComponent(rowData.team_name);
        navigate(`/clients/${selectedTeamsIds[0]}/1/${encodedLabel}`);
        //setSelectedTeams([rowData.id_team])
    }

    const categoryBodyTemplate = (rowData) => {
        switch (rowData.category) {
            case "Demande de Profil":
                return <Tag value="Demande de Profil" severity="info" />;
            case "Besoin Profil Interne":
                return <Tag value="Besoin Profil Interne" severity="primary" />;
            case "Projet Bureautique":
                return <Tag value="Projet Bureautique" severity="success" />;
            case "Projet Infra":
                return <Tag value="Projet Infra" severity="warning" />;
            case "Infogérance":
                return <Tag value="Infogérance" severity="secondary" />;
            case "Autres":
                return <Tag value="Autres" severity="danger" />;
            default:
                return <Tag value="Unknown" severity="danger" />;
        }
    }

    const statusBodyTemplate = (rowData) => {
        switch (rowData.status) {
            case "Non démarré":
                return <Tag value="Non démarré" severity="secondary" />;
            case "En cours":
                return <Tag value="En cours" severity="info" />;
            case "Clos Gagné":
                return <Tag value="Clos Gagné" severity="success" />;
            case "Clos Abandonné":
                return <Tag value="Clos Abandonné" severity="warning" />;
            case "Clos Perdu":
                return <Tag value="Clos Perdu" severity="danger" />;
            case "Non pris en charge":
                return <Tag value="Non pris en charge" severity="danger" />;
            default:
                return <Tag value="Inconnu" severity="danger" />;
        }
    }

    const subStatusBodyTemplate = (rowData) => {
        switch (rowData.sub_status) {
            case "-":
                return <Tag value="-" severity="secondary" />;
            case "Recherche de profils":
                return <Tag value="Recherche de profils" severity="info" />;
            case "RDV candidats":
                return <Tag value="RDV candidats" severity="primary" />;
            case "CV(s) transmis":
                return <Tag value="CV(s) transmis" severity="success" />;
            case "Relance":
                return <Tag value="Relance" severity="warning" />;
            case "Attente retour client":
                return <Tag value="Attente retour client" severity="warning" />;
            case "Attente retour Responsable de compte":
                return <Tag value="Attente retour Responsable de compte" severity="warning" />;
            default:
                return <Tag value="Inconnu" severity="danger" />;
        }
    }

    const teamBodyTemplate = (rowData) => {
        return (
            <a className={styles.linkStyle} onClick={() => navToTeam(rowData)}>{rowData.team_name}</a>
        )
    }

    const tableHeader = () => {
        return (<Row>
            <Col lg={6}>
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                </IconField>
            </Col>
            <Col md={6} className="d-flex justify-content-end">
                {checkPermission(config.scopes.opportunities, config.permissionTypes.edit) &&
                    <ImageButton
                        image={addIcon}
                        imageFocus={addIconFocus}
                        onClick={() => {
                            setAddOpportunitieModalVisible(true);
                        }}
                        active={true}
                        width={32}
                    />}
                <ImageButton
                    image={exportIcon}
                    imageFocus={exportIconFocus}
                    onClick={exportExcelOpportunities}
                    active={true}
                    width={32}
                />
            </Col>

        </Row>
        )
    }

    const statusRowFilterTemplate = (options) => {
        return (
            <Dropdown value={options.value}
                options={['Non démarré', 'En cours', 'Clos Gagné', 'Clos Abandonné', 'Clos Perdu', 'Non pris en charge']}
                onChange={(e) => options.filterApplyCallback(e.value)}
                placeholder={<Langs str={"Select"} />}
                className="p-column-filter"
                showClear
                style={{ minWidth: '12rem' }}
            />
        )
    }

    const priorityRowFilterTemplate = (options) => {
        return (
            <Dropdown value={options.value}
                options={['Urgent', 'Normale', 'Faible']}
                onChange={(e) => options.filterApplyCallback(e.value)}
                placeholder={<Langs str={"Select"} />}
                className="p-column-filter"
                showClear
                style={{ minWidth: '12rem' }}
            />
        )
    }

    const categotyRowFilterTemplate = (options) => {
        return (
            <Dropdown value={options.value}
                options={['Demande de Profil', 'Besoin Profil Interne', 'Projet Bureautique', 'Projet Infra', 'Infogérance', 'Autres']}
                onChange={(e) => options.filterApplyCallback(e.value)}
                placeholder={<Langs str={"Select"} />}
                className="p-column-filter"
                showClear
                style={{ minWidth: '12rem' }}
            />
        )
    }

    const subStatusRowFilterTemplate = (options) => {
        return (
            <Dropdown value={options.value}
                options={['-', 'Recherche de profils', 'RDV candidats', 'CV(s) transmis', 'Relance', 'Attente retour client', 'Attente retour Responsable de compte']}
                onChange={(e) => options.filterApplyCallback(e.value)}
                placeholder={<Langs str={"Select"} />}
                className="p-column-filter"
                showClear
                style={{ minWidth: '12rem' }}
            />
        )
    }

    const startDateTemplate = (rowData) => {
        return <strong>{moment(rowData.start_date).format('DD/MM/YYYY')}</strong>
    }

    let scrollHeight = "calc(100vh - 280px)"
    switch (isMobile) {
        case 2:
            scrollHeight = "calc(100vh - 330px)"
            break
        case 3:
            scrollHeight = "calc(100vh - 280px)"
            break
        default:
            break
    }

    return (
        <div className="bodyCard">
            <DataTable value={localOppList}
                onValueChange={(data) => setFilteredOpportunities(data)}
                tableStyle={{ maxWidth: '30rem' }}
                scrollable
                scrollHeight={scrollHeight}
                paginator
                paginatorTemplate={"FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"}
                currentPageReportTemplate={`{first} ${Localize("to")} {last} ${Localize("of")} {totalRecords}`}
                rows={10}
                rowsPerPageOptions={[10, 25, 50]}
                draggable={false}
                filters={filters}
                globalFilterFields={['poste_name', 'title', 'localisation', 'description', 'status', 'competences', 'team_name', 'category', 'priority', 'demanded_by_nom', 'demanded_by_prenom', 'handled_by_nom', 'handled_by_prenom', 'helped_by_prenom', 'helped_by_nom', 'sub_status', 'response_comments']}
                header={tableHeader}
                onRowDoubleClick={onRowDoubleClick}
                selectionMode="single"
                ref={dtOpp}
            >
                <Column exportable sortable filter field="title" style={{ minWidth: "15rem" }} header={Localize("Titre")}></Column>
                <Column exportable sortable filter field="localisation" header={Localize("Localisation")}></Column>
                <Column exportable sortable filter field="poste_name" header={"Poste"}></Column>
                <Column exportable sortable filter field="priority" body={priorityBodyTemplate} filterElement={priorityRowFilterTemplate} showFilterMatchModes={false} header={Localize("Priorité")}></Column>
                <Column exportable sortable filter field="category" body={categoryBodyTemplate} filterElement={categotyRowFilterTemplate} showFilterMatchModes={false} header={Localize("Catégorie")}></Column>
                <Column exportable sortable filter field="status" body={statusBodyTemplate} showFilterMatchModes={false} filterElement={statusRowFilterTemplate} header={Localize("Statut")}></Column>
                <Column exportable sortable filter field="sub_status" body={subStatusBodyTemplate} style={{ minWidth: "12rem" }} filterElement={subStatusRowFilterTemplate} showFilterMatchModes={false} header={Localize("Sous-Statut")}></Column>
                <Column exportable sortable filter field="team_name" body={teamBodyTemplate} header={Localize("TEAM")}></Column>
                <Column exportable sortable field="profiles_number" header={Localize("Profils recherchés")} style={{ minWidth: "15rem" }}></Column>
                <Column exportable sortable field="provided_profiles_number" header={Localize("Profils fournis")} style={{ minWidth: "13rem" }}></Column>
                <Column exportable sortable field="start_date" body={startDateTemplate} header={Localize("START_DATE")} style={{ minWidth: "10rem" }}></Column>
                <Column exportable sortable filter field="competences" body={competenceTemplate} style={{ minWidth: "30rem" }} header={Localize("Compétences")}></Column>
                <Column exportable field="description" filter body={(rowData) => textTemplate(rowData, 'description')} header="Description" style={{ minWidth: "18rem" }}></Column>
                <Column exportable filter field="response_comments" body={(rowData) => textTemplate(rowData, 'response_comments')} header="Commentaires" style={{ minWidth: "18rem" }}></Column>
                <Column exportable sortable filter field="demanded_by_nom" header={"Demandé par (Nom)"} style={{ minWidth: "16rem" }}></Column>
                <Column exportable sortable filter field="demanded_by_prenom" header={"Demandé par (Prénom)"} style={{ minWidth: "17rem" }}></Column>
                <Column exportable sortable filter field="handled_by_nom" header={"Géré par (Nom)"} style={{ minWidth: "16rem" }}></Column>
                <Column exportable sortable filter field="handled_by_prenom" header={"Géré par (Prénom)"} style={{ minWidth: "16rem" }}></Column>
                <Column exportable sortable filter field="helped_by_nom" header={"Aidé par (Nom)"} style={{ minWidth: "16rem" }}></Column>
                <Column exportable sortable filter field="helped_by_prenom" header={"Aidé par (Prénom)"} style={{ minWidth: "16rem" }}></Column>
            </DataTable>
            <OpportunityModal
                type={detailsModalVisibility ? "EDIT" : "ADD"}
                visible={detailsModalVisibility || addOpportunitieModalVisible}
                setVisible={detailsModalVisibility ? setDetailsModalVisibility : setAddOpportunitieModalVisible}
                onViewItem={detailsModalVisibility ? oppDetailed : null}
                setOnViewItem={setOppDetailed}
            />
        </div>
    )
}